/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function GateCodeField (props: FormTextFieldProps) {
  const { name = 'gateCode', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'gateCode',
        defaultMessage: 'Code du portail'
      })}
      name={name}
      {...others}
    />
  )
}

export default GateCodeField
